import ApiService from "services/ApiService";

export const MfaService = {
    getMfaTypes() {
        return new Promise((resolve, reject) => {
            ApiService.get('/account/Options/MFA').then(
                 (result) => {
                     resolve(result.data);
                 },
                 (error) => {
                     reject(error);
                 });
        });
    },

    getAccountMfaSettings() {
        return new Promise((resolve, reject) => {
            ApiService.get('/account/MFA').then(
                 (result) => {
                     resolve(result.data);
                 },
                 (error) => {
                     reject(error);
                 });
        });
    },

    saveAccountMfaSettings(settings) {
        return new Promise((resolve, reject) => {
            ApiService.put('/account/MFA', settings).then(
                 (result) => {
                     resolve(result.data);
                 },
                 (error) => {
                     reject(error);
                 });
        });
    },

    getCurrentUserMfaSettings() {
        return new Promise((resolve, reject) => {
            ApiService.get('/user/Me/MFA').then(
                 (result) => {
                     resolve(result.data);
                 },
                 (error) => {
                     reject(error);
                 });
        });
    },

    getUserMfaSettings(userId) {
        return new Promise((resolve, reject) => {
            ApiService.get(`/user/mfa/user/${userId}`).then(
                 (result) => {
                     resolve(result.data);
                 },
                 (error) => {
                     reject(error);
                 });
        });
    },

    resetMfaForUser(userId) {
        return new Promise((resolve, reject) => {
            ApiService.patch(`/user/mfa/user/${userId}/reset`).then(
                 (result) => {
                     resolve(result.data);
                 },
                 (error) => {
                     reject(error);
                 });
        });
    },

    resetMfaForCurrentUser() {
        return new Promise((resolve, reject) => {
            ApiService.patch(`/user/me/mfa/reset`).then(
                 (result) => {
                     resolve(result.data);
                 },
                 (error) => {
                     reject(error);
                 });
        });
    }
}